export function doDeleteAction(screen_data): void {
  if (screen_data.ids.length >= screen_data.length_items_without_filters) {
    console.log("screen_data.ids.length", screen_data.ids.length, ">= screen_data.length_items_without_filters", screen_data.length_items_without_filters)
    screen_data.showMessage("Debes quedarte al menos con una empresa.", 'mdi-alert');
    return;
  }
  console.log("screen_data.ids.length:", screen_data.ids.length, "<", "screen_data.length_items_without_filters:", screen_data.length_items_without_filters)
  screen_data.setMessageModal({
    text: 'Se borrarán las empresas seleccionadas.',
    showQuestion: true,
    showCancelButton: true,
    textQuestion: '¿Está seguro?',
    textConfirmButton: 'Sí',
    textCancelButton: 'No',
    actionConfirmButton: screen_data.deleteItems,
    actionCancelButton: screen_data.noDeleteItems
  });
}

export async function doDownloadExcelCompanydbs(screen_data): Promise<void> {
  try{
    const response = await screen_data.exportCru({
      url: 'export_companydbs/', 
      ids: screen_data.ids, 
      send_filters: screen_data.send_filters
    });
    screen_data.asyncJobId = response.data['AsyncJob'];
    screen_data.documentName = "empresas";
    screen_data.documentFormat = "xlsx";
    screen_data.downloadJobState = "running";
  }catch(err){
    screen_data.showMessage('Algo ha ido mal.');
    console.error(err)
  }

}

export async function doRefreshAccounts(screen_data): Promise<void> {
  screen_data.loadingAction = true;
  try{
    await screen_data.refreshAccounts(screen_data.ids)
    screen_data.showMessage(
      'Las empresas seleccionadas están actualizando sus proveedores y clientes.',
      'mdi-information-outline');
    screen_data.selected = [];
  }catch(err){
    console.error(err);
    screen_data.showMessage('Algo ha ido mal.')
  }finally{
    screen_data.refresh();
    screen_data.loadingAction = false;
  }
}

export function doMassiveChange(screen_data): void {
  screen_data.massiveDialog = true;
}

export function doMassiveAddLink(screen_data): void{
  const curr_year = new Date().getFullYear().toString()
  screen_data.min_date = curr_year+'-01-01';
  screen_data.max_date = curr_year+'-12-31';
  screen_data.start_ejercicio = curr_year+'-01-01';
  screen_data.end_ejercicio = curr_year+'-12-31';
  screen_data.year_ejercicio = curr_year + '';
  screen_data.massiveAddLinkDialog = true;
}

export function doMassiveDeactivateLinkDialog (screen_data): void{
  screen_data.massiveDeactivateLinkDialog = true;
}

export function doMassiveChangeLink(screen_data): void{
  screen_data.change_link_type = 'max_date';
  screen_data.change_link_year = (new Date().getFullYear()).toString();
  screen_data.new_link_date = (new Date().getFullYear()).toString()+'-12-31';
  screen_data.massiveChangeLinkDialog = true;
}

export function doDownloadMassiveCsv(screen_data): void{
  if (screen_data.user_data_available_features?.['feature_csv_multiple_companies']) {
    screen_data.csv_date_range = {start: undefined, end: undefined}
    screen_data.downloadMassiveCsvDialog = true // open dialog
  }
  else console.debug("'download_massive_csv' called without corresponding feature 'feature_csv_multiple_companies'")
}

export function doAccountMassiveCsv(screen_data): void{
  if (screen_data.user_data_available_features?.['feature_csv_multiple_companies']) {
    screen_data.toDoneCompanyCsvInvoices()
    console.log('account_massive_csv')
  }
  else console.debug("'account_massive_csv' called without corresponding feature 'feature_csv_multiple_companies'")
}

export function doMassiveUpdateConfirmationMail(screen_data): void{
  if (screen_data.user_data_available_features?.['feature_massive_update_confirmation_email']) {
    screen_data.updateMassiveConfirmationMailDialog = true  // open dialog
  }
  else console.debug("'massive_update_confirmation_mail' called without corresponding feature 'feature_massive_update_confirmation_email'")
}

export function doMassiveUpdateLoadPaths(screen_data): void{
  if (screen_data.user_data_available_features?.['feature_massive_update_load_paths']) {
    screen_data.updateMassiveLoadPaths() // Executes command
    console.log('massive_update_load_paths')
  }
  else console.debug("'massive_update_load_paths' called without corresponding feature 'feature_massive_update_load_paths'")
}

export function showPopupMassiveUpdateIsArchived(screen_data): void{
  screen_data.showMassiveUpdateIsArchivedDialog = true
}

export function doActionUtils(screen_data): void{
  if (screen_data.selected){
    screen_data.ids = screen_data.selected.map(item => item.id);
  }
  if (screen_data.selected_action === 'delete') {
    doDeleteAction(screen_data);
  }
  else if (screen_data.selected_action == 'download_excel_companydbs') {
    doDownloadExcelCompanydbs(screen_data);
  } 
  else if (screen_data.selected_action == 'refresh_accounts') {
    doRefreshAccounts(screen_data)
  } 
  else if (screen_data.selected_action == 'massive_change') {
    doMassiveChange(screen_data)
  } 
  else if (screen_data.selected_action == 'massive_add_link') {
    doMassiveAddLink(screen_data)
  } 
  else if (screen_data.selected_action == 'massive_deactivate_link') {
    doMassiveDeactivateLinkDialog(screen_data)
  } 
  else if (screen_data.selected_action == 'massive_change_link') {
    doMassiveChangeLink(screen_data)
  } 
  else if (screen_data.selected_action == 'download_massive_csv') {
    doDownloadMassiveCsv(screen_data)
  } 
  else if (screen_data.selected_action == 'account_massive_csv') {
    doAccountMassiveCsv(screen_data) 
  } 
  else if (screen_data.selected_action == 'massive_update_confirmation_mail') {
    doMassiveUpdateConfirmationMail(screen_data)
  } 
  else if (screen_data.selected_action == 'massive_update_load_paths') {
    doMassiveUpdateLoadPaths(screen_data)
  }
  else if (screen_data.selected_action == 'massive_update_is_archived') {
    showPopupMassiveUpdateIsArchived(screen_data)
  }
  else {
    console.debug('Not Implemented');
  }
 }